import { render, staticRenderFns } from "./DashboardMenu.vue?vue&type=template&id=def241fe&scoped=true&"
import script from "./DashboardMenu.vue?vue&type=script&lang=js&"
export * from "./DashboardMenu.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMenu.vue?vue&type=style&index=0&id=def241fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def241fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cognatis/api/frontend/foundation/dev/webapp/vue-project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('def241fe', component.options)
    } else {
      api.reload('def241fe', component.options)
    }
    module.hot.accept("./DashboardMenu.vue?vue&type=template&id=def241fe&scoped=true&", function () {
      api.rerender('def241fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/legend/DashboardMenu.vue"
export default component.exports